import { size } from "polished";
import styled from "styled-components";
import media from "styled-media-query";

import { themes } from "styles";

export const Container = styled.div`
  ion-icon {
    ${size("13px")}

    margin-left: 8px;
    fill: ${themes.palletes.info};

    ${media.greaterThan("huge")}
    ${size("16px")}
  }
`;
